<template>
  <layout-login>
    <v-form v-model="formulario" autocomplete="off">
      <div
        class="rectangle"
        :style="`background-image: linear-gradient(to bottom, ${entityConfig.backgroundGradienColorFrom}, ${entityConfig.backgroundGradienColorTo});`"
      >
        <div class="row" style="text-align: center">
          <div class="col-sm-12 py-5">
            <img
              :src="entityConfig.loginLogoUrl"
              width="250"
              alt="logo"
              class="crn-logo-confirming"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-sm">
            <div class="group-5">
              <div class="row">
                <v-col cols="11" sm="11" md="11" style="padding-top: 13%">
                  <p class="source-sans-pro-ligh">
                    {{ $t("MSAUTH01") }}
                  </p>
                </v-col>
              </div>

              <div class="row">
                <v-col cols="12" sm="12" md="12">
                  <label class="label-login">{{ $t("MSAUTH02") }}</label>
                  <v-text-field
                    :color="entityConfig.primaryColor"
                    placeholder="nombreapellido@mail.com"
                    outlined
                    dense
                    max="50"
                    maxlength="50"
                    counter
                    v-model="email"
                    :rules="[rules.required, rules.email]"
                  ></v-text-field>
                </v-col>
              </div>

              <div class="row">
                <v-col cols="12" sm="12" md="12">
                  <label class="label-login">{{
                    $t("login.Contraseña")
                  }}</label>
                  <v-text-field
                    :color="entityConfig.primaryColor"
                    placeholder="************"
                    outlined
                    dense
                    counter
                    maxlength="30"
                    v-model="password"
                    :rules="[rules.required, rules.min, rules.max]"
                    :type="show1 ? 'text' : 'password'"
                    :append-icon="show1 ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="show1 = !show1"
                  ></v-text-field>
                </v-col>
              </div>

              <div class="row">
                <v-col cols="12" sm="12" md="12">
                  <p class="olvidaste-tu-contra">
                    <a
                      class="no-estas-registrado-2"
                      :style="`color: ${entityConfig.primaryColor}`"
                      @click="$router.push('/forgot-password')"
                      >{{ $t("login.olvidastesTuContraseña") }}</a
                    >
                  </p>
                </v-col>
              </div>

              <div class="row">
                <v-col cols="12" sm="12" md="12">
                  <v-btn
                    class="btn rectangle-button"
                    block
                    depressed
                    :disabled="!formIsValid"
                    @click="postlogin"
                    :color="entityConfig.primaryColor"
                    :style="`color: ${entityConfig.secondaryColor}`"
                  >
                    {{ $t("MSAUTH01") }}
                  </v-btn>
                </v-col>
              </div>

              <div class="row">
                <v-col cols="12" sm="12" md="12">
                  <div class="no-estas-registrado">
                    <small class="no-estas-registrado">
                      {{ $t("login.noseharegistadotodavia") }}
                    </small>
                    <br />

                    <small>
                      <a
                        class="no-estas-registrado-2"
                        style="
                          text-decoration: none;
                          font-weight: bold !important;
                        "
                        :style="`color: ${entityConfig.primaryColor}`"
                        @click="$router.push('/company-data')"
                      >
                        {{ $t("login.Crearcontra") }}
                      </a></small
                    >
                  </div>
                </v-col>
              </div>
            </div>
          </div>
        </div>
      </div>
      <overlay :visible="spinner" :opacity="1"></overlay>
      <cookies @accepted="cookies = false" :visibleCookies="cookies"></cookies>
    </v-form>
  </layout-login>
</template>

<style scoped lang="scss">
@import "./login.style";
</style>

<script>
import LayoutLogin from "../../components/layouts/layout-login.vue";

import Api from "../../Services/index";
import Overlay from "../../components/layouts/overlay.vue";
import Cookies from "../../components/layouts/cookies.vue";

export default {
  name: "App",
  components: { Overlay, "layout-login": LayoutLogin, Cookies },
  data() {
    return {
      cookies: false,
      dialog: true,
      bntActivo: true,
      formulario: false,
      show1: false,
      spinner: true,
      entityConfig: {},
      codNrbeEn: "",
      email: "",
      password: "",
      rules: {
        email: (value) => {
          const pattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
          return (
            pattern.test(value) ||
            "Debe ser una dirección de correo electrónico con formato correcto"
          );
        },
        required: (value) => !!value || "Este campo es requerido.",
        min: (v) =>
          v.length >= 12 || "La contraseña debe tener minimo 12 caracteres",
        max: (v) =>
          v.length <= 30 || "La contraseña debe tener maximo 30 caracteres",
        emailMatch: () => `The email and password you entered don't match`,
      },
    };
  },
  mounted() {
    setTimeout(() => {
      this.entityConfig = this.$store.state.entityConfig.config;
      this.codNrbeEn = sessionStorage.getItem("codNrbeEn");
      this.spinner = false;

      let cookiGet = localStorage.getItem("cookies-" + this.codNrbeEn);
      if (cookiGet) {        
        let fechaVencimiento = new Date(parseInt(cookiGet))
        let fechaEstaVencido =  (new Date()).getTime() >= fechaVencimiento.getTime()
        if (fechaEstaVencido){
          localStorage.removeItem("cookies-" + this.codNrbeEn );
        }
        this.cookies = fechaEstaVencido;
      } else {
        this.cookies = Boolean(this.entityConfig.cookiesText);
      }
    }, 1000);
  },
  computed: {
    formIsValid() {
      return this.formulario && this.bntActivo;
    },
  },

  methods: {
    Register() {
      this.$router.push("confirmation-data");
    },
    async postlogin() {
      this.spinner = true;
      try {
        this.bntActivo = false;
        const formData = new FormData();

        formData.append("email", this.email);
        formData.append("password", this.password);
        formData.append("codNrbeEn", this.codNrbeEn);

        const obj = Object.fromEntries(formData);
        const response = await Api.post("/login", obj);
        if (response.data.response.token) {
          const authToken = response.data.response.token;
          sessionStorage.setItem("alias", response.data.response.alias);
          sessionStorage.setItem("authtoken", authToken);
          const base64Payload = authToken.split(".")[1];
          const userData = decodeURIComponent(
            escape(window.atob(base64Payload))
          );
          sessionStorage.setItem("userData", userData);
          this.$router.push({ path: "home" });
          this.spinner = false;
        }
      } catch (error) {
        this.$showError(this, error.response.data);
        this.spinner = false;
      } finally {
        this.bntActivo = true;
      }
    },
  },
};
</script>
